import React from "react";

const SvgTop = props => (
  <svg
    style={{
      isolation: "isolate",
      width: '100%',
    }}
    viewBox="0 0 100 24.6"
    {...props}
    fill="currentColor" 
  >
    <defs>
      <clipPath id="Top_svg__a">
        <path fill="currentColor" d="M0 0h100v24.6H0z" />
      </clipPath>
    </defs>
    <g fill="currentColor"  clipPath="url(#Top_svg__a)">
      <path fill="currentColor" d="M100 20.953l-.247-14.048c-.016-3.404-2.8-6.221-6.229-6.281L6.406.001A6.26 6.26 0 0 0 1.87 1.823 6.245 6.245 0 0 0 0 6.347l.124 16.162c.003.98.685 1.801 1.601 2.025a2.099 2.099 0 0 0 2.604-2.056l-.008-.942 93.538 1.562a2.123 2.123 0 0 0 1.524-.619c.407-.403.625-.956.617-1.526zM4.291 17.326L4.204 6.323a2.113 2.113 0 0 1 .625-1.51 2.12 2.12 0 0 1 1.531-.608l87.117.627c.156-.001.311.02.458.056a2.125 2.125 0 0 1 1.609 2.061l.21 11.9-91.463-1.523z" />
      <path fill="currentColor" d="M24.114 18.636L13.484 1.115a2.105 2.105 0 0 0-2.889-.708 2.107 2.107 0 0 0-.708 2.89l10.629 17.525c.303.495.777.823 1.3.951a2.107 2.107 0 0 0 2.298-3.137zM45.218 18.99L34.577 1.466a2.105 2.105 0 0 0-3.597 2.182l10.638 17.523a2.109 2.109 0 0 0 2.893.709 2.106 2.106 0 0 0 .707-2.89zM66.307 19.341L55.691 1.818A2.105 2.105 0 0 0 52.094 4L62.71 21.523c.304.494.777.823 1.301.951a2.104 2.104 0 0 0 2.296-3.133zM87.386 19.693L76.766 2.17a2.106 2.106 0 0 0-2.889-.708 2.106 2.106 0 0 0-.708 2.89l10.62 17.523c.304.495.778.823 1.301.951a2.1 2.1 0 0 0 1.589-.243 2.106 2.106 0 0 0 .707-2.89z" />
    </g>
  </svg>
);

export default SvgTop;